import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import { useTranslation } from 'react-i18next';
import { Dialog, Link } from '@anticatrade/shared';

interface AddProductDialogProps {
	isOpen: boolean;
	onClose: () => void;
	disabled: boolean;
}

const AddProductDialog = ({ isOpen, onClose, disabled }: AddProductDialogProps) => {
	const { t } = useTranslation();

	return (
		<Dialog
			title={t('Add item')}
			className='add-product-dialog'
			isOpen={isOpen}
			onAfterHide={onClose}
			variant='neutral'
		>
			<div className='add-product-dialog__tiles'>
				<Link path='add'>
					<button
						className='add-product-dialog__tile'
						onClick={onClose}
						disabled={disabled}
					>
						<SlIcon name='plus-square' className='add-product-dialog__tile-icon' />
						<div className='add-product-dialog__tile-text'>
							<span className='add-product-dialog__tile-title'>
								{t('Create a new item')}
							</span>
							<span className='add-product-dialog__tile-description'>
								{t('Create a new item description')}
							</span>
						</div>
					</button>
				</Link>
				<Link path='import'>
					<button
						className='add-product-dialog__tile'
						onClick={onClose}
						disabled={disabled}
					>
						<SlIcon name='link-45deg' className='add-product-dialog__tile-icon add-product-dialog__tile-icon--link' />
						<div className='add-product-dialog__tile-text'>
							<span className='add-product-dialog__tile-title'>
								{t('Import from link')}
							</span>
							<span className='add-product-dialog__tile-description'>
								{t('Import from link description')}
							</span>
						</div>
					</button>
				</Link>
			</div>
		</Dialog>
	);
};

export { AddProductDialog };
